export function focus(node: HTMLElement) {
  queueMicrotask(() => node.focus());
}
